import TabCoaches from "@/views/App/Dashboard/HeadOccupationalTherapy/TabCoaches.vue";
import TabInfo from "@/views/App/Dashboard/HeadOccupationalTherapy/TabInfo.vue";


const routesDashboardHeadOccupationalTherapy = [
    {
        path: 'info',
        name: 'dashboardHeadOccupationalTherapyInfo',
        component: TabInfo
    },
    {
        path: 'coaches',
        name: 'dashboardHeadOccupationalTherapyCoaches',
        component: TabCoaches
    }
  ];

export default routesDashboardHeadOccupationalTherapy;